<template>
  <div class="c-field-preset-team-default-toggle">
    <div class="flex flex-col gap-4">
      <h4 class="font-bold text-neutral-text-strong text-base m-0">
        Set as team default
      </h4>
      <p class="text-neutral-text text-sm m-0">
        Pre-selected for everyone on your team when they configure sharing.
        Change it anytime.
      </p>
    </div>
    <component :is="isLocked ? BittsTooltip : 'div'" placement="topRight">
      <BittsSwitch v-model="isToggled" :disabled="isLocked" />
      <template v-if="isLocked" #title>
        Your team always needs one default preset. To change it, set a different
        preset as the team default.
      </template>
    </component>
  </div>
</template>

<script setup lang="ts">
import { BittsSwitch, BittsTooltip } from '@crossbeam/bitts';

const { isLocked } = defineProps<{ isLocked: boolean }>();

const isToggled = defineModel<boolean>({ required: true });
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";

.c-field-preset-team-default-toggle {
  @apply flex items-center justify-between gap-16 mb-16 p-16 border border-neutral-border rounded-8;
}
</style>
